import { defineMessages } from 'react-intl';

export default defineMessages({
    coverages: {
        id: 'endorsement.common.views.coverages.Coverages',
        defaultMessage: 'Coverages'
    },
    mainCoverages: {
        id: 'endorsement.common.views.coverages.Main Coverages Premium',
        defaultMessage: 'Main Coverages Premium'
    },
    additionalCoverages: {
        id: 'endorsement.views.selectAction.cart.Additional Coverages',
        defaultMessage: 'Additional Coverages'
    },
    schedules: {
        id: 'endorsement.views.selectAction.cart.Schedule Items',
        defaultMessage: 'Schedule Items'
    },
    liabiliyCoverages: {
        id: 'endorsement.views.selectAction.cart.Liability Coverages',
        defaultMessage: 'Liability Coverages'
    },
    packageSpecificCoverages:{
        id: 'endorsement.views.selectAction.cart.Package Specific Coverages',
        defaultMessage: 'Package Specific Coverages'
    },
    addExtension:{
        id: 'endorsement.views.selectAction.cart.Add',
        defaultMessage:'Add'
    }
});
